export const ExploreFundSection = ({ EXPLORE_FUNDS }) => (
  <div className="lil-bg-blue-50 lil-mt-10 lil-pt-12 lil-pb-24">
    <div className="lil-container">
      <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32 lil-py-5">
        Explore mutual funds
      </h2>
      <div className="lil-flex sm:lil-flex-col">
        <div className="lil-w-1/3 sm:lil-w-full">
          <h6 className="lil-mb-5">Best hybrid funds</h6>
          {EXPLORE_FUNDS.bestHybridFunds.map((ele, index) => (
            <a
              className="lil-text-base lil-mb-3 lil-text-font-400 sm:lil-text-s-14 lil-block lil-cursor-pointer"
              href={ele.link}
              key={`${ele.title}${index}`}
            >
              {ele.title}
            </a>
          ))}
          <h6 className="lil-my-5">Mutual fund types</h6>
          {EXPLORE_FUNDS.mutualFundsType.map((ele, index) => (
            <a
              className="lil-text-base lil-mb-3 lil-text-font-400 sm:lil-text-s-14 lil-block lil-cursor-pointer"
              href={ele.link}
              key={`${ele.title}${index}`}
            >
              {ele.title}
            </a>
          ))}
        </div>
        <div className="lil-w-1/3 sm:lil-w-full">
          <h6 className="lil-mb-5">Best duration funds</h6>
          {EXPLORE_FUNDS.bestDurationFunds.map((ele, index) => (
            <a
              className="lil-text-base lil-mb-3 lil-text-font-400 sm:lil-text-s-14 lil-block lil-cursor-pointer"
              href={ele.link}
              key={`${ele.title}${index}`}
            >
              {ele.title}
            </a>
          ))}
        </div>
        <div className="lil-w-1/3 sm:lil-w-full">
          <h6 className="lil-mb-5">Best equity funds</h6>
          {EXPLORE_FUNDS.bestEquityFunds.map((ele, index) => (
            <a
              className="lil-text-base lil-mb-3 lil-text-font-400 sm:lil-text-s-14 lil-block lil-cursor-pointer"
              href={ele.link}
              key={`${ele.title}${index}`}
            >
              {ele.title}
            </a>
          ))}
          <h6 className="lil-my-5">Best debt funds</h6>
          {EXPLORE_FUNDS.bestDebtFunds.map((ele, index) => (
            <a
              className="lil-text-base lil-mb-3 lil-text-font-400 sm:lil-text-s-14 lil-block lil-cursor-pointer"
              href={ele.link}
              key={`${ele.title}${index}`}
            >
              {ele.title}
            </a>
          ))}
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/exploreFundsSection.tsx